import React from "react"
import { Container, Row, Col } from "reactstrap"

import { CURRENT_YEAR } from "../utils/constants"

const Footer = () => (
  <footer className="footer">
    <Container>
      <div className="footer__inner">
        <Row className="justify-content-between">
          <Col sm={12}>
            © {CURRENT_YEAR} ООО «АРОНОВ И ПАРТНЕРЫ» ВСЕ ПРАВА ЗАЩИЩЕНЫ.
          </Col>
          <Col sm={12}>
            <p>
              Настоящий информационный ресурс (интернет сайт strikeoff.ru),
              любая информация и результаты интеллектуальной деятельности,
              размещенные на нем, защищены законодательством Российской
              Федерации. Незаконное использование, копирование, воспроизведение
              или распространение любой информации и результатов
              интеллектуальной деятельности или их частей, размещенных на данном
              интернет сайте, влечет ответственность в соответствии с
              законодательством Российской Федерации. Правообладатели
              результатов интеллектуальной деятельности, размещенных на данном
              информационном ресурсе, не предоставляют третьим лицам
              исключительных прав на результаты интеллектуальной деятельности,
              размещенные на данном информационном ресурсе.
            </p>
          </Col>
        </Row>
      </div>
    </Container>
  </footer>
)

export default Footer
